import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'readingDetails',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      loading: true,
      menuVisible: true,
      selectedTab: 'readings',
      scrollAmt: 200,
      Custkey: '',
      ConnectionId: null,
      MeterId: null,
      ReadingNo: null,
      lang: '',
      tabs: [],
      reading: null,
      photosCols: [],

      images: [],

      imagesPageingOptions: { pageSize: 10, total: 0, page: 1 },
      imagesTotalRow: 0,
    }
  },
  computed: {
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function () {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrl(val);
    },
  },
  created() {
    this.ConnectionId = this.$route.params.ConnectionId;
    this.MeterId = this.$route.params.MeterId;
    this.ReadingNo = this.$route.params.ReadingNo;

    this.tabs = [
      {
        id: 'readings',
        show: true,
        ...this.enqIcons.readings
      },
      {
        id: "otherDetails",
        label: this.$t("enquiriesPropertyDetails.otherDetails"),
        show: true,
        icon: this.enqIcons.info.icon,
      },
      {
        id: "images",
        show: true,
        ...this.enqIcons.images
      },
    ];

    this.findDefaultTab();
  },
  mounted() {
    this.getReadingDetails();
  },
  methods: {
    scrollTabs(dir) {
      if (dir == 'left') {
        document.getElementById('tabsDiv').scrollLeft += this.scrollAmt;
      }
      else {
        document.getElementById('tabsDiv').scrollLeft -= this.scrollAmt;
      }
    },
    getReadingDetails() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        MeterId: this.MeterId,
        ReadingNo: this.ReadingNo,
        loginEmail: this.getLoginName()
      }

      //console.log(parameters);

      axios.post('/Enquiries/GetReadingDetails', parameters)
        .then(response => {
          if (response.status == 200) {
            //console.log('response.data', response.data);
            this.reading = response.data.readingData;

            this.photosCols = [];
            this.photosCols.push({ dataField: 'IMG_DATETIME', caption: this.$t('enquiriesReadingsDetails.photoDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHMMSS });
          }
          else
            this.getDataFailed();
        })
        .then(a => {
          this.fillImages();
        })
        .catch(e => {
          this.getDataFailed(e);
        })
        .finally(() => this.loading = false)
    },
    imagesPageChange(pInfo) {
      this.imagesPageingOptions.page = pInfo.pageNumber;
      this.imagesPageingOptions.pageSize = pInfo.pageSize;
      this.fillImages();
    },
    fillImages() {
      var parameters = {
        connectionId: this.ConnectionId,
        meterId: this.MeterId,
        readingNo: this.ReadingNo,
        loginEmail: this.getLoginName(),
        Options: this.imagesPageingOptions
      }

      axios.post('/Enquiries/getReadingImages', parameters)
        .then(response => {
          if (response.status == 200) {
            this.images = response.data.items;

            this.imagesTotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  return false; })
    }
  },
}
